module.exports = __webpack_public_path__ + "img/MACU TEA.2f21a741.svg";